module.exports = __webpack_public_path__ + "media/images/mailer/thumb_800-a43d4d92667648e8d2064960fd226d2f.jpg";